import TabsPage from '../TabsPage';

import './index.less';
import './themes/default.less';

import ContentBlock from "components/ContentBlock";
import ItemPerson from 'components/ItemPerson';

import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';
import { ReactComponent as CheckIcon } from 'icons/components/check.svg';

export default class General extends TabsPage {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            absol: true,
        };
    }

    onAddFamilyAcc(info, obj) {
        this.props.openDialog("addFamily", info, obj, this.props.refresh);
    }

    onDeleteFamilyAcc(info, e) {
        this._helper.stopEvent(e);

        this.props.openDialog("deleteFamily", info, this.props.refresh);
    }

    async onConfirmFamilyAcc(info, e) {
        this._helper.stopEvent(e);

        this._helper.showLoading();

        const obj = { ...info, status: "APPROVED" };
        delete obj.id;

        await this._request.clientRelations.update(info.id, obj);

        this._helper.hideLoading();

        this.props.refresh();
    }

    onChangeNotes(info) {
        this.props.openDialog("changeNote", info, this.props.updateClient, "general");
    }

    renderPersData(personalData, info) {
        if (!personalData)
            return false;
        const { PHONE_1, EMAIL, ADDRESS, PSP_SERIES, PSP_NUMBER, PSP_ISSUE_DATE, PSP_ISSUED_BY, PSP_DEP_CODE } = personalData;
        const { knowAboutClinicDetails, clientDynamicData } = info;
        const passportRow = `${PSP_SERIES || ""} ${PSP_NUMBER || ""}, выдан ${PSP_ISSUE_DATE || ""} ${PSP_ISSUED_BY || ""} ${PSP_DEP_CODE || ""}`;

        let recom = "";
        if (knowAboutClinicDetails) {
            const { recommendationType, recommenderClient, recommenderEmployeeId, recommenderEmployeeViaClientId, } = knowAboutClinicDetails;
            recom = recommendationType.title;

            if (recommendationType.id === 6) {
                recom += " " + this._helper.string.formatFullName(recommenderClient, "short");

                if (recommenderEmployeeViaClientId)
                    recom += " на доктора " + this._helper.string.formatFullName(this.props.getDoctorById(recommenderEmployeeViaClientId), "short");

            } else if (recommendationType.id === 5 && recommenderEmployeeId) {
                recom += " " + this._helper.string.formatFullName(this.props.getDoctorById(recommenderEmployeeId), "short");
            }
        }

        return (
            <div className="content flex col gap8">
                {PHONE_1 && this.renderRow("client.homePhone", <div>{PHONE_1}</div>)}
                {EMAIL && this.renderRow("client.email", <div>{EMAIL}</div>, "Blue")}
                {ADDRESS && this.renderRow("client.homeAddress", <div>{ADDRESS}</div>)}
                {PSP_SERIES && this.renderRow("client.passport", <div className="flex1">{passportRow}</div>)}
                {recom && this.renderRow("client.learned", recom)}
                {clientDynamicData && Object.keys(clientDynamicData).length > 0 &&
                    Object.keys(clientDynamicData).map((it, i) => (this.renderRow(it, <div key={i}>
                        {(clientDynamicData[it] && clientDynamicData[it].includes("http")) ? this.linkify(clientDynamicData[it]) : clientDynamicData[it]}
                    </div>, false, i)))}
            </div>
        );
    }

    renderHistory(info) {
        const { changedBy, changedTime, createdBy, createdTime } = info;

        const created = `${this._helper.string.formatFullName(this.props.getDoctorById(createdBy), "short")} ${this._helper.date.toStr(createdTime, "D MMMM YYYY")}`;
        const revision = `${this._helper.string.formatFullName(this.props.getDoctorById(changedBy), "short")} ${this._helper.date.toStr(changedTime, "D MMMM YYYY")}`;

        return (
            <div className="content flex col gap4">
                {this.renderRow("client.created", <div>{created}</div>)}
                {this.renderRow("client.revision", <div>{revision}</div>)}
            </div>
        );
    }

    renderAttendance(lastVisit, firstVisit, absenceVisits, completedVisits, latenessVisits, recommendationCount) {
        const lastVisitDoctor = (lastVisit && lastVisit.doctorId) ? this._helper.string.formatFullName(this.props.getDoctorById(lastVisit.doctorId)) : "-";
        const firstVisitDoctor = (firstVisit && firstVisit.doctorId) ? this._helper.string.formatFullName(this.props.getDoctorById(firstVisit.doctorId)) : "-";

        return (
            <>
                <div className="content flex col gap4">
                    {this.renderRow("client.lastVisit", <div>{lastVisit ? this._helper.date.toStr(lastVisit.endDate, "D MMMM YYYY") : "-"}</div>)}
                    {this.renderRow("client.doctor", <div>{lastVisitDoctor}</div>)}
                </div>
                <div className="content flex col gap4">
                    {this.renderRow("client.firstVisit", <div>{firstVisit ? this._helper.date.toStr(firstVisit.beginDate, "D MMMM YYYY") : "-"}</div>)}
                    {this.renderRow("client.cause", <div>{firstVisit ? firstVisit.reasonName : "-"}</div>)}
                    {this.renderRow("client.doctor", <div>{firstVisitDoctor}</div>)}
                </div>
                <div className="content flex col gap4">
                    {this.renderRow("client.completed", <div>{completedVisits ? completedVisits : this.tr("client.missing")}</div>)}
                    {this.renderRow("client.recommendations", <div>{recommendationCount ? recommendationCount : this.tr("client.missing")}</div>)}
                    {this.renderRow("client.absences", <div>{absenceVisits ? absenceVisits : this.tr("client.missing")}</div>)}
                    {this.renderRow("client.late", <div>{latenessVisits ? latenessVisits : this.tr("client.missing")}</div>)}
                </div>
            </>
        );
    }

    renderFinancial(clientBalance, discount, totalSum, totalPaidSum) {
        const { balance, bonus, bonusesMisty, availableBonusesMisty } = clientBalance;
        const { toSum } = this._helper.number;

        return (
            <div className="contFin flex gap24">
                <div className="content flex1 flex col gap4">
                    {this.renderRow("invoice.balance", toSum(balance))}
                    {this.renderRow("client.bonus", toSum(bonus))}
                    {bonusesMisty !== undefined && this.renderRow("Бонусы Misty",
                        <div className="flex gap8">
                            <div data-tooltip="Всего бонусов">{`${toSum(bonusesMisty)}`}</div>
                            <div data-tooltip="Неактивные бонусы">{`(${toSum(availableBonusesMisty - bonusesMisty)})`}</div>
                        </div>)}
                    {this.renderRow("client.discount", <div>{discount ? discount : 0}%</div>)}

                </div>
                <div className="content flex1 flex col gap4">
                    {this.renderRow("client.duty", toSum(totalSum - totalPaidSum), "Red")}
                    {this.renderRow("client.invoices", <div>{toSum(totalSum)}</div>)}
                    {this.renderRow("client.paid", <div>{toSum(totalPaidSum)}</div>)}
                </div>
            </div>
        );
    }

    getIconForFamily(isPend, it) {
        return (
            <div className="familyButtons flex gap16 centerV">
                {isPend && <CheckIcon className="familyButton hand" data-tooltip="main.confirm" onClick={this.onConfirmFamilyAcc.bind(this, it)} />}
                <CloseIcon className="familyButton hand" data-tooltip="client.delete" onClick={this.onDeleteFamilyAcc.bind(this, it)} />
            </div>
        );
    }

    renderFamily(items, info) {
        const { relations } = this._config;

        return (
            <div className="content flex col gap4">
                {items.map((it, j) => {
                    const relObj = relations.find(inf => inf.id === it.relationType);
                    const isPend = it.status === "PENDING";
                    const comment = it.note ? ` (${it.note})` : "";

                    const infoItem = it.clientTo.id === info.id ? it.clientFrom : it.clientTo;

                    return (
                        <div key={j}>
                            <ItemPerson
                                className="itemFamily"
                                info={infoItem}
                                iconRight={this.getIconForFamily(isPend, it)}
                                firstRowClick={this._helper.openClient.bind(this._helper, infoItem?.id, {})}
                                secondRow={`${this.tr(relObj?.name)}, ${this.tr(isPend ? "client.pending" : "client.agreed")}${comment}`}
                                onClick={this.onAddFamilyAcc.bind(this, info, it)}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }

    linkify(text) {
        const urlRegex = /\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]/gi;
        const urls = text.match(urlRegex) || [];
        const uniqueMarkers = urls.map((url, index) => `URL_MARKER_${index}`);

        let textWithMarkers = text;
        uniqueMarkers.forEach((marker, index) => {
            textWithMarkers = textWithMarkers.replace(urls[index], marker);
        });

        return textWithMarkers.split(/URL_MARKER_\d+/).reduce((acc, part, index) => {
            acc.push(part);
            if (index < urls.length) {
                acc.push(
                    <a key={index} className="link" href={urls[index]} target="_blank" rel="noopener noreferrer">
                        {urls[index]}
                    </a>
                );
            }
            return acc;
        }, []);

    }

    renderContent() {
        const { info, openRightPopup, insurance } = this.props;
        const { personalData, clientBalance, discount, lastVisit,
            firstVisit, /*comment,*/ familyChildren, familyParents, invoiceList,
            absenceVisits, completedVisits, latenessVisits, recommendationCount,
            /*birthday*/
        } = info;

        let familyList = [];

        ([...(familyParents || []), ...(familyChildren || [])]).forEach(it => {
            const { clientFrom, clientTo } = it;
            const memberId = clientFrom.id === info.id ? clientTo.id : clientFrom.id;
            let newMember = true;
            familyList.forEach(member => {
                const listMemberId = member.clientFrom.id === info.id ? member.clientTo.id : member.clientFrom.id;
                if (listMemberId === memberId)
                    newMember = false;
            });

            if (newMember)
                familyList.push(it);
        });

        info.familyList = familyList.map(it => {
            return it.clientTo.id === info.id ? it?.clientFrom.id : it?.clientTo.id;
        });

        const { totalSum, totalPaidSum } = this._helper.getBalanceClient(invoiceList);
        info.insuranceComp = insurance;
        info.totalSum = totalSum;
        info.totalPaidSum = totalPaidSum;

        return (
            <div className="wrapGeneral flex flex1 gap16">
                <div className="columnContent flex col flex1 gap16">
                    <ContentBlock
                        title="client.persData"
                        icons={[
                            {
                                name: "edit",
                                onClick: openRightPopup.bind(this, "editInfo", info, this.props.updateClient, "edit")
                            }, {
                                name: "arrow",
                                onClick: openRightPopup.bind(this, "editInfo", info, this.props.updateClient, "view")
                            }]}>
                        {this.renderPersData(personalData, info)}
                    </ContentBlock>
                    {/*<ContentBlock
                        title="client.note"
                        icon={{
                            name: "edit",
                            onClick: this.onChangeNotes.bind(this, info)
                        }}
                    >
                        <div className="text p1">{(comment && comment.includes("http")) ? this.linkify(comment) : comment}</div>
                    </ContentBlock>*/}
                    <ContentBlock
                        title="client.family"
                        icon={{
                            name: "plus",
                            tooltip: "client.addFamilyAcc",
                            onClick: this.onAddFamilyAcc.bind(this, info, null)
                        }}
                    >
                        {this.renderFamily(familyList, info)}
                    </ContentBlock>
                </div>
                <div className="columnContent flex col flex1 gap16">
                    <ContentBlock title="client.financial">
                        {this.renderFinancial(clientBalance, discount, totalSum, totalPaidSum)}
                    </ContentBlock>
                    <ContentBlock title="client.attendance">
                        {this.renderAttendance(lastVisit, firstVisit, absenceVisits, completedVisits, latenessVisits, recommendationCount)}
                    </ContentBlock>
                    <ContentBlock title="client.history">
                        {this.renderHistory(info)}
                    </ContentBlock>
                </div>
            </div >
        );
    }
}
